var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_POLICY_VIOLATION,
          expression: "PERMISSIONS.VIEW_POLICY_VIOLATION",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: {
                xs: "6",
                sm: "4",
                md: "4",
                lg: "2",
                id: "filter-controls",
              },
            },
            [
              _c(
                "div",
                [
                  _c("h3", { staticStyle: { display: "inline" } }, [
                    _vm._v(_vm._s(this.$t("message.filters"))),
                  ]),
                  _c(
                    "b-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "md", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.clearAllFilters()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(this.$t("message.clear_all"))
                      ),
                    ]
                  ),
                  _c("br"),
                  _c("br"),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "showInactive-form-group",
                        label: this.$t("message.projects"),
                      },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            id: "showInactive-form-checkbox",
                            value: "true",
                            "unchecked-value": "false",
                          },
                          model: {
                            value: _vm.showInactive,
                            callback: function ($$v) {
                              _vm.showInactive = $$v
                            },
                            expression: "showInactive",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                this.$t("message.show_inactive_projects")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "showSuppressed-form-group",
                        label: this.$t("message.analysis_status"),
                      },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            id: "showSuppressed-form-checkbox",
                            value: "true",
                            "unchecked-value": "false",
                          },
                          model: {
                            value: _vm.showSuppressed,
                            callback: function ($$v) {
                              _vm.showSuppressed = $$v
                            },
                            expression: "showSuppressed",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                this.$t("message.show_suppressed_violations")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "violation-state-form-group",
                        label: this.$t("message.violation_state"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "violation-state-form-checkbox-group",
                          options: _vm.violationStateOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.violationStateSelected,
                          callback: function ($$v) {
                            _vm.violationStateSelected = $$v
                          },
                          expression: "violationStateSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "risk-type-form-group",
                        label: this.$t("message.risk_type"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "risk-type-form-checkbox-group",
                          options: _vm.riskTypeOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.riskTypeSelected,
                          callback: function ($$v) {
                            _vm.riskTypeSelected = $$v
                          },
                          expression: "riskTypeSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "analysis-type-form-group",
                        label: this.$t("message.analysis_state"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "analysis-type-form-checkbox-group",
                          options: _vm.analysisStateOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.analysisStateSelected,
                          callback: function ($$v) {
                            _vm.analysisStateSelected = $$v
                          },
                          expression: "analysisStateSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "occurred-on-date-form-group",
                        label: this.$t("message.occurred_on"),
                      },
                    },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          id: "occurred-on-datepicker-from",
                          max: _vm.occurredOnDateTo,
                          placeholder: this.$t("message.from"),
                        },
                        model: {
                          value: _vm.occurredOnDateFrom,
                          callback: function ($$v) {
                            _vm.occurredOnDateFrom = $$v
                          },
                          expression: "occurredOnDateFrom",
                        },
                      }),
                      _c("b-datepicker", {
                        attrs: {
                          id: "occurred-on-datepicker-to",
                          min: _vm.occurredOnDateFrom,
                          placeholder: this.$t("message.to"),
                        },
                        model: {
                          value: _vm.occurredOnDateTo,
                          callback: function ($$v) {
                            _vm.occurredOnDateTo = $$v
                          },
                          expression: "occurredOnDateTo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "text-search-form-group",
                        label: this.$t("message.text_search"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "text-search-form-input",
                          debounce: "750",
                          placeholder: this.$t("message.search"),
                        },
                        model: {
                          value: _vm.textSearchInput,
                          callback: function ($$v) {
                            _vm.textSearchInput = $$v
                          },
                          expression: "textSearchInput",
                        },
                      }),
                      _vm._v("\n          Search in:\n          "),
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "text-search-form-checkbox-group",
                          options: _vm.textSearchOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.textSearchSelected,
                          callback: function ($$v) {
                            _vm.textSearchSelected = $$v
                          },
                          expression: "textSearchSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: _vm.PERMISSIONS.POLICY_MANAGEMENT,
                          expression: "PERMISSIONS.POLICY_MANAGEMENT",
                        },
                      ],
                      attrs: {
                        id: "policy-form-group",
                        label: this.$t("message.policies"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "policy-form-checkbox-group",
                          options: _vm.policyOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.policySelected,
                          callback: function ($$v) {
                            _vm.policySelected = $$v
                          },
                          expression: "policySelected",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-col",
            { attrs: { xs: "6", sm: "8", md: "8", lg: "10" } },
            [
              _c("bootstrap-table", {
                ref: "table",
                attrs: {
                  columns: _vm.columns,
                  data: _vm.data,
                  options: _vm.options,
                },
                on: { "on-load-success": _vm.onLoadSuccess },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }